module.exports = __webpack_public_path__ + "img/ring_r_c_0_1@2x.0f73c65e.png";